{
  "name": "@apfelkiste/device",
  "version": "1.18.2",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.api/homer": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/script": "*",
    "@homer.core/storage.local": "*",
    "@homer.utility/hash": "*",
    "@unifold/core": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
